import * as XLSX from 'xlsx';
import { FormSubmission, ContactForm } from './firebaseService';

export const exportToExcel = (submissions: FormSubmission[], filename: string = 'syrdevuae-submissions') => {
  // Transform submissions data for Excel
  const excelData = submissions.map((submission, index) => ({
    'No.': index + 1,
    'Submission ID': submission.id || 'N/A',
    'Status': submission.status,
    'Submitted Date': submission.submittedAt ? submission.submittedAt.toDate().toLocaleString() : 'N/A',
    
    // Personal Information
    'Full Name': submission.name,
    'Birth Year': submission.birthYear || 'N/A',
    'Emirates of Residence': submission.emiratesOfResidence || 'N/A',
    'Referred By': submission.referredBy || 'N/A',
    'Phone Number': submission.phoneNumber,
    'LinkedIn Account': submission.linkedinAccount,
    'Email Address': submission.email,
    
    // Academic Information
    'Education Level': submission.educationLevel,
    'Field of Study': submission.otherFieldOfStudy || submission.fieldOfStudy,
    'University/Institute': submission.universityName,
    'Courses Completed': submission.coursesCompleted || 'N/A',
    
    // Professional Information
    'Current Position': submission.currentPosition || 'N/A',
    'Company Name': submission.companyName || 'N/A',
    'Looking for Job': submission.lookingForJob ? 'Yes' : 'No',
    'Professional Journey': submission.professionalJourney || 'N/A',
    'Community Helped with Income/Employment': submission.communityHelpedEmployment || 'N/A',
    'Technical Skills': (submission.skills || []).join(', ') || 'N/A',
    
    // Additional Information
    'Interested in Speaking': submission.interestedInSpeaking || 'N/A',
    'Speaking Topics': submission.speakingTopics || 'N/A',
    'Interested in Entrepreneurship': submission.interestedInEntrepreneurship || 'N/A',
    'Has Project/Idea Requiring Support': submission.hasProjectIdea || 'N/A',
    'Project/Idea Description': submission.projectIdeaDescription || 'N/A',
    'Interested in Volunteering': submission.interestedInVolunteering || 'N/A',
    'Volunteer Team': submission.volunteerTeam || 'N/A',
    'General Note': submission.generalNote || 'N/A',
  }));

  // Create workbook and worksheet
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(excelData);

  // Set column widths for better readability
  const columnWidths = [
    { wch: 5 },   // No.
    { wch: 15 },  // Submission ID
    { wch: 12 },  // Status
    { wch: 20 },  // Submitted Date
    { wch: 25 },  // Full Name
    { wch: 12 },  // Birth Year
    { wch: 20 },  // Emirates of Residence
    { wch: 25 },  // Referred By
    { wch: 20 },  // Phone Number
    { wch: 35 },  // LinkedIn Account
    { wch: 30 },  // Email Address
    { wch: 20 },  // Education Level
    { wch: 25 },  // Field of Study
    { wch: 30 },  // University/Institute
    { wch: 40 },  // Courses Completed
    { wch: 25 },  // Current Position
    { wch: 25 },  // Company Name
    { wch: 15 },  // Looking for Job
    { wch: 50 },  // Professional Journey
    { wch: 35 },  // Community Helped with Income/Employment
    { wch: 40 },  // Technical Skills
    { wch: 20 },  // Interested in Speaking
    { wch: 40 },  // Speaking Topics
    { wch: 25 },  // Interested in Entrepreneurship
    { wch: 30 },  // Has Project/Idea Requiring Support
    { wch: 50 },  // Project/Idea Description
    { wch: 50 },  // General Note
  ];
  worksheet['!cols'] = columnWidths;

  // Add worksheet to workbook
  XLSX.utils.book_append_sheet(workbook, worksheet, 'SyrDevUae Submissions');

  // Generate filename with current date
  const currentDate = new Date().toISOString().split('T')[0];
  const finalFilename = `${filename}-${currentDate}.xlsx`;

  // Export the file
  XLSX.writeFile(workbook, finalFilename);
};

export const exportFilteredToExcel = (
  submissions: FormSubmission[], 
  statusFilter: string | null,
  filename: string = 'syrdevuae-submissions'
) => {
  let filteredSubmissions = submissions;
  
  if (statusFilter && statusFilter !== 'all') {
    filteredSubmissions = submissions.filter(sub => sub.status === statusFilter);
  }
  
  const statusSuffix = statusFilter && statusFilter !== 'all' ? `-${statusFilter}` : '';
  const finalFilename = `${filename}${statusSuffix}`;
  
  exportToExcel(filteredSubmissions, finalFilename);
};

export const exportContactFormsToExcel = (contactForms: ContactForm[], filename: string = 'syrdevuae-contact-forms') => {
  // Transform contact forms data for Excel
  const excelData = contactForms.map((contactForm, index) => ({
    'No.': index + 1,
    'Contact ID': contactForm.id || 'N/A',
    'Status': contactForm.status,
    'Submitted Date': contactForm.submittedAt ? contactForm.submittedAt.toDate().toLocaleString() : 'N/A',
    
    // Contact Information
    'Full Name': contactForm.name,
    'Email Address': contactForm.email,
    'Message': contactForm.message,
  }));

  // Create workbook and worksheet
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(excelData);

  // Set column widths for better readability
  const columnWidths = [
    { wch: 5 },   // No.
    { wch: 15 },  // Contact ID
    { wch: 12 },  // Status
    { wch: 20 },  // Submitted Date
    { wch: 25 },  // Full Name
    { wch: 30 },  // Email Address
    { wch: 80 },  // Message
  ];
  worksheet['!cols'] = columnWidths;

  // Add worksheet to workbook
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Contact Forms');

  // Generate filename with current date
  const currentDate = new Date().toISOString().split('T')[0];
  const finalFilename = `${filename}-${currentDate}.xlsx`;

  // Export the file
  XLSX.writeFile(workbook, finalFilename);
}; 